<div class="text-center" *ngIf="loading">
  <i class="fas fa-spinner fa-pulse fa-3x"></i>
</div>
<div class="alert alert-danger mt-3" *ngIf="loadError && !loading">
  {{ loadError }}
  <button type="button" class="btn btn-outline-danger btn-sm ml-2" (click)="retryLoad()">Retry</button>
</div>
<div *ngIf="matter_id && searchOptionsLoaded && !loadError">
  <div class="row mt-3">
    <div class="col-md-10 ml-md-auto mr-md-auto">
      <div class="row">
        <div class="col-md-2">
          <div class="form-check">
            <label class="form-check-label">
              <input class="form-check-input" type="checkbox" [(ngModel)]="search_params.showNonBillable" (change)="filterChanged()" />
              <img [src]="search_options.heart_asset" *ngIf="search_options" />
              Non-Billable
            </label>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-check">
            <label class="form-check-label">
              <input class="form-check-input" type="checkbox" [(ngModel)]="search_params.showPending" (change)="filterChanged()" />
              <img [src]="search_options.hourglass_asset" *ngIf="search_options" />
              Pending
            </label>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-check">
            <label class="form-check-label">
              <input class="form-check-input" type="checkbox" [(ngModel)]="search_params.showAuthorized" (change)="filterChanged()" />
              <img [src]="search_options.tick_asset" *ngIf="search_options" />
              Authorized
            </label>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-check">
            <label class="form-check-label">
              <input class="form-check-input" type="checkbox" [(ngModel)]="search_params.showBilled" (change)="filterChanged()" />
              <img [src]="search_options.coins_asset" *ngIf="search_options" />
              Billed
            </label>
          </div>
        </div>
        <div class="col-md-4 text-center">
          <ul class="pagination pagination-sm justify-content-center mb-0">
            <li class="page-item" [class.disabled]="noPreviousPage()">
              <button type="button" class="page-link" [disabled]="noPreviousPage()" (click)="selectPage(1, $event)">&laquo;</button>
            </li>
            <li class="page-item" [class.disabled]="noPreviousPage()">
              <button type="button" class="page-link" [disabled]="noPreviousPage()" (click)="selectPage(search_params.page - 1, $event)">&lsaquo;</button>
            </li>
            <li class="page-item" *ngFor="let page of visiblePages()" [class.active]="page === search_params.page">
              <button type="button" class="page-link" (click)="selectPage(page, $event)">{{ page }}</button>
            </li>
            <li class="page-item" [class.disabled]="noNextPage()">
              <button type="button" class="page-link" [disabled]="noNextPage()" (click)="selectPage(search_params.page + 1, $event)">&rsaquo;</button>
            </li>
            <li class="page-item" [class.disabled]="noNextPage()">
              <button type="button" class="page-link" [disabled]="noNextPage()" (click)="selectPage(totalPages(), $event)">&raquo;</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-1 text-center"><h5>Id/Bill Id</h5></div>
    <div class="col-1 text-center"><h5>Date</h5></div>
    <div class="col-3"><h5>Description</h5></div>
    <div class="col-2 text-center"><h5>By</h5></div>
    <div class="col-2 text-center"><h5>Activity</h5></div>
    <div class="col-1 text-right"><h5>Rate</h5></div>
    <div class="col-1 text-right"><h5>Time</h5></div>
    <div class="col-1 text-right"><h5>Amount</h5></div>
  </div>
  <div class="row py-3 odd-color-mute" *ngFor="let billing of billings" style="font-size: 85%">
    <div class="col-1 text-center">
      <a [href]="'/billings/' + billing.id">{{ billing.id }}</a>
      &nbsp;/&nbsp;
      <a *ngIf="billing.bill_id > 0" [href]="'/bills/' + billing.bill_id">{{ billing.bill_id }}</a>
      <span *ngIf="billing.bill_id <= 0" class='text-muted'>Nil</span>
    </div>
    <div class="col-1 text-center" [title]="billing.rendered_at_time" [tooltip]="billing.rendered_at_time">
      {{ billing.rendered_at_date }}
    </div>
    <div class="col-3">
      <span *ngIf="billing.icon_path"><img [src]="billing.icon_path" />&nbsp;&nbsp;</span>
      {{ billing.description }}
    </div>
    <div class="col-2 text-center">
      <span [ngClass]="{ 'text-warning': billing.user_name == 'User missing', 'text-danger': billing.user_name == 'User not specified' }">
        {{ billing.user_name }}
      </span>
    </div>
    <div class="col-2 text-center">
      {{billing.activity_name}}
    </div>
    <div class="col-1 text-right">
      {{ billing.rate | currency: 'USD':'symbol-narrow':'1.2-2' }}
    </div>
    <div class="col-1 text-right">
      {{ billing.quantity | number: '1.2-2' }}
    </div>
    <div class="col-1 text-right">
      {{ billing.rate * billing.quantity | currency: 'USD':'symbol-narrow':'1.2-2' }}
    </div>
  </div>
</div>
